import { render } from "./AccountRegister.vue?vue&type=template&id=64522532&scoped=true"
import script from "./AccountRegister.vue?vue&type=script&lang=js"
export * from "./AccountRegister.vue?vue&type=script&lang=js"

import "./AccountRegister.vue?vue&type=style&index=0&id=64522532&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64522532"]])

export default __exports__